import {fileMetadataAdapter} from "./media-lib.reducer";
import {getMediaLibFeature} from "./media-lib.selector";

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = fileMetadataAdapter.getSelectors(getMediaLibFeature);
